module.exports = __webpack_public_path__ + "img/State=6.0f5de3e4.svg";